import CryptoJS from 'crypto-js';

// Derive a key from the password using PBKDF2 (simple example; you might adjust iterations/salt)
function deriveKey(password) {
  // A static salt is shown here for simplicity; in production, use a random salt stored in localStorage.
  const salt = CryptoJS.enc.Utf8.parse('some-static-salt');
  const key128Bits = CryptoJS.PBKDF2(password, salt, { keySize: 128/32, iterations: 1000 });
  return key128Bits;
}

export function encryptPrivateKey(privateKey, password) {
  const key = deriveKey(password);
  const encrypted = CryptoJS.AES.encrypt(privateKey, key.toString()).toString();
  return encrypted;
}

export function decryptPrivateKey(encryptedKey, password) {
  const key = deriveKey(password);
  const bytes = CryptoJS.AES.decrypt(encryptedKey, key.toString());
  const decrypted = bytes.toString(CryptoJS.enc.Utf8);
  return decrypted;
}
